import React from 'react';
import { HeroBackgroundLinesSvg } from './styles';

const HeroBackgroundLines: React.FC = () => (
  <HeroBackgroundLinesSvg
    viewBox="0 0 1920 1195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
    preserveAspectRatio="none"
  >
    <path
      d="M1511 586C1523.57 582.881 1535.1 580.274 1545.53 578.228C1834.57 513.036 1921.37 684.275 1759.43 701.875C1656.82 713.027 1687.78 829.975 1946.57 786.167C2065.23 766.08 2171.68 705.66 2219.76 635.591"
      stroke="#EB6424"
      strokeWidth={10}
      strokeLinecap="round"
      pathLength={1}
    />
    <path
      d="M656.327 784.626C397.895 852.609 40.9277 687.477 -41.4322 272.245M656.327 784.626C710.536 770.366 760.409 745.849 802.502 711.232C912.348 620.898 833.371 505.444 709.581 601.632C643.677 652.842 609.864 727.012 656.327 784.626ZM656.327 784.626C680.682 814.826 727.094 840.477 802.502 855.887C925.405 881.004 1039.5 866.856 1116.05 849.569"
      stroke="#EB6424"
      strokeWidth={10}
      strokeLinecap="round"
      pathLength={1}
    />
  </HeroBackgroundLinesSvg>
);

export default HeroBackgroundLines;
